export type { SkeletonsProps } from './SkeletonsProps';
export { Skeletons } from "./Skeletons";